import store from './store/index.js';

const toKey = name => `BROWSER_ENV_${name}`;

export default function cache(name, fn) {
  const key = toKey(name);
  
  return function accessCache() {
    try {
      const cached = store.getItem(key);
      if (cached !== null) return JSON.parse(cached).value;
    } catch {}

    const value = fn();
    try {
      store.setItem(key, JSON.stringify({ value }));
    } catch {}
    return value;
  };
};